import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject, take, takeUntil } from 'rxjs';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { UserService } from 'src/app/core/user/user.service';
import { MatGridListModule } from '@angular/material/grid-list';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-my-embed-list',
  imports: [CommonModule, MatGridListModule],
  templateUrl: './my-embed-list.component.html',
  styleUrl: './my-embed-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyEmbedListComponent implements OnInit, OnDestroy {
  public companyUuid: string = '';
  public companyProjectList: Array<any> = [];

  private unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private userSerivce: UserService,
    private threeGraphqlSerivce: ThreeGraphqlService,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.getCompanyProjectList();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onClickCreateEmbed(): void {
    this.threeGraphqlSerivce
      .createCompanyProjects(this.companyUuid, 'Test Project')
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((companyProject: any) => {
        this.router.navigate(['edit', companyProject.uuid]);
      });
  }

  public onClickDeleteEmbed(project: any): void {
    this.threeGraphqlSerivce
      .deleteCompanyProject(project.uuid)
      .pipe(take(1))
      .subscribe((success: boolean) => {
        if (!success) return;
        this.companyProjectList = this.companyProjectList.filter(
          (item: any) => item.uuid !== project.uuid,
        );
        this.cd.markForCheck();
      });
  }

  public onClickEditProject(project: any): void {
    this.router.navigate(['edit', project.uuid]);
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------

  private getCompanyProjectList(): void {
    if (!this.userSerivce.email) return;
    this.threeGraphqlSerivce
      .getCompanyProjects(this.userSerivce.email)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((company: any) => {
        console.log('company', company);
        this.companyUuid = company.uuid;
        console.log('companyUuid', this.companyUuid);
        this.companyProjectList = company.companyProjects;
        this.cd.markForCheck();
      });
  }
}
